export const getStatesFromShipToLocationCountry = (shipToLocations, countryCode) =>
    shipToLocations.find(country => country.country === countryCode).administrativeAreas;


// WEBPACK FOOTER //
// ./src/app/services/addressUtils.js